<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'PDF_BATCH_GENERATION' }
  ]"
></breadcrumbs>
<page-header title="PDF_BATCH_GENERATION"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="">
      <data-generation-section
        *ngFor="let stat of stats"
        [data]="stat"
      ></data-generation-section>
      <content-loading *ngIf="stats.length == 0"></content-loading>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="
        isLoading || checkIfRunning() || getField(['forceStopReceived'])
      "
      type="button"
      class="button is-success"
      (click)="start()"
      translationEditableDirective="START"
    >
      {{ 'START' | translate }}
    </button>
  </div>
  <div class="control">
    <button
      (click)="stop()"
      [disabled]="
        isLoading || !checkIfRunning() || getField(['forceStopReceived'])
      "
      type="button"
      class="button is-link is-light"
      translationEditableDirective="STOP"
    >
      {{ 'STOP' | translate }}
    </button>
  </div>
</div>
